import { render, staticRenderFns } from "./HistoricoBeneficiario.vue?vue&type=template&id=e42bdf5a&scoped=true"
import script from "./HistoricoBeneficiario.vue?vue&type=script&lang=js"
export * from "./HistoricoBeneficiario.vue?vue&type=script&lang=js"
import style0 from "./HistoricoBeneficiario.vue?vue&type=style&index=0&id=e42bdf5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42bdf5a",
  null
  
)

export default component.exports